export class DriftProtectionPolicy {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "numberOfAttachedResources",
            "baseName": "numberOfAttachedResources",
            "type": "number",
            "format": ""
        },
        {
            "name": "numberOfDetachedResources",
            "baseName": "numberOfDetachedResources",
            "type": "number",
            "format": ""
        },
        {
            "name": "numberOfExcludedResources",
            "baseName": "numberOfExcludedResources",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DriftProtectionPolicy.attributeTypeMap;
    }
    constructor() {
    }
}
